import { optional, qsa } from '@/lib/dom'

const ACTIVE = 'is-active'

/**
 * SP のハンバーガーメニュー。
 * CSS 側は `header ul.is-active`（表示）と `header button.is-active`（×印）を見ている。
 */
export function initMenu(): void {
  const trigger = optional<HTMLButtonElement>('.js-menu-trigger')
  const overlay = optional('.js-menu-overlay')
  if (!trigger || !overlay) return

  const setOpen = (open: boolean): void => {
    trigger.classList.toggle(ACTIVE, open)
    overlay.classList.toggle(ACTIVE, open)
    trigger.setAttribute('aria-expanded', String(open))
  }

  trigger.setAttribute('aria-label', 'メニュー')
  trigger.setAttribute('aria-expanded', 'false')

  trigger.addEventListener('click', () => {
    setOpen(!trigger.classList.contains(ACTIVE))
  })

  // メニュー項目を選んだら閉じる（スクロール自体はインライン onclick の lenis が担当）
  qsa('.c-menu-item', overlay).forEach((item) => {
    item.addEventListener('click', () => setOpen(false))
  })

  document.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key === 'Escape') setOpen(false)
  })
}
